import { Type } from "class-transformer";
import { TransactionDto } from "@dto/transactionDto";
import { IEntity } from "@interfaces/entity";
import { Customer } from "./customer";
import { User } from "./identity/user";
import { Transaction } from "./transaction";
import { Address } from "./address";

export class DeliveryNote implements IEntity {
  id: number;

  deliveryNoteNumber: string;

  transactions: Transaction[] | TransactionDto[];

  deliveryPeriodStart: Date;
  deliveryPeriodEnd: Date;
  deliveryNoteSendTimestamp: Date;

  @Type(() => User)
  userId: string;
  user: User;

  @Type(() => Address)
  addressId: number;
  address: Address;

  @Type(() => Customer)
  customerId: number;
  customer: Customer;

  entityName = "DeliveryNote";

  constructor(formValue?: Partial<DeliveryNote>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<DeliveryNote>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
